<template>
  <div>
    <b-icon
      icon="x-octagon"
      variant="danger"
      animation="throb"
      font-scale="8"
    />
    <hr />
    <h3 class="mb-0">{{ $t("general.sure") }}</h3>
    <p>{{ $t("general.deleteMsg") }}</p>
  </div>
</template>

<script>
export default {
  name: "Delete",
  props: {
    data: Object,
    modalName: String,
    modalEvent: Function,
    save: Boolean,
    saveState: Function,
    formName: String
  },
  watch: {
    save: async function(data) {

      if (data) {
        switch (this.formName) {
          case "AccountType":
            await this.$store.dispatch("deleteAccountType", this.data);
            await this.$store.dispatch("listAccountType");
            break;
          case "Address":
            switch (this.data.type) {
              case "country":
                await this.$store.dispatch("deleteCountry", this.data);
                await this.$store.dispatch("country_list");
                break;
              case "city":
                await this.$store.dispatch("deleteCity", this.data);
                await this.$store.dispatch("city_list", this.data.country_id);
                break;
              case "town":
                await this.$store.dispatch("deleteTown", this.data);
                await this.$store.dispatch("town_list", {
                  city: this.data.city_id,
                  country: this.data.country_id
                });
                break;
            }
            break;
          case "Panel":
            switch (this.data.type) {
              case "brand":
                await this.$store.dispatch("deleteBrands", this.data);
                await this.$store.dispatch("listBrands");
                break;
              case "model":
                await this.$store.dispatch("deleteModels", this.data);
                await this.$store.dispatch("listModels", this.data.brand_id);
                break;
            }
            break;
          case "Subscriptions":
            await this.$store.dispatch("deleteSubscription", this.data);
            await this.$store.dispatch("subscription_list");
            break;
          case "Job":
            await this.$store.dispatch("deleteJobs", this.data);
            await this.$store.dispatch("listJobs");
            break;
          case "ZoneType":
            await this.$store.dispatch("deleteZoneTypes", this.data);
            await this.$store.dispatch("listZoneTypes");
            break;
          case "SignalProtocol":
            if (this.data.modalType === "eventCode") {
            await this.$store.dispatch("deleteEventCodes", this.data.item);
            await this.$store.dispatch("listEventCodes",{protocol:this.data.selectedProtocol});
            }
            else {
            await this.$store.dispatch("deleteProtocols", this.data);
            await this.$store.dispatch("listProtocols");
            }
            break;
          case "Groups":
            await this.$store.dispatch("deleteSignalGroups", this.data);
            await this.$store.dispatch("signal_group_list");
            break;
          case "SignalDesc":
            await this.$store.dispatch("deleteSignalTypes", this.data);
            await this.$store.dispatch("listSignalTypes");
            break;
          case "QuickNote":
            await this.$store.dispatch("deleteQuickNotes", this.data);
            await this.$store.dispatch("listQuickNotes");
            break;
          case "Products":
            await this.$store.dispatch("deleteProducts", this.data);
            await this.$store.dispatch("listProducts", this.data.params);
            break;
          case "StockMovementType":
            await this.$store.dispatch("deleteStockMovementTypes", this.data);
            await this.$store.dispatch("listStockMovementTypes");
            break;
          case "FaultSupportPieces":
            await this.$store.dispatch("deleteFaultSupportPieces", this.data);
            await this.$store.dispatch("listFaultSupportPieces");
            break;
          case "FaultSupportResults":
            await this.$store.dispatch("deleteFaultSupportResult", this.data);
            await this.$store.dispatch("listFaultSupportResults");
            break;
          case "ImportantNumber":
            await this.$store.dispatch("deleteImportantNumbers", this.data);
            await this.$store.dispatch("listImportantNumbers");
            break;
          case "Vacations":
            await this.$store.dispatch("deleteVacations", this.data);
            await this.$store.dispatch("listVacations");
            break;
          case "VacationsJobs":
            await this.$store.dispatch("deleteVacationJobs", this.data);
            await this.$store.dispatch("listVacationJobs", {vacationId: this.data.vacationId});
            break;
          case "EvaluationResult":
            await this.$store.dispatch("deleteEvaluationResults", this.data);
            await this.$store.dispatch("listEvaluationResults");
            break;
          case "Task":
            await this.$store.dispatch("deleteTasks", this.data);
            await this.$store.dispatch("listTasks");
            break;
          case "Receivers":
            await this.$store.dispatch("deleteRec", this.data);
            await this.$store.dispatch("listReceivers");
            break;
          case "ReceiverProtocol":
            switch (this.data.modalType) {
              case "format":
                await this.$store.dispatch("deleteRecFormat", this.data.item);
                await this.$store.dispatch("listFormats", this.data.item.receiver_protocol_id);
                break;
            }
           await this.$store.dispatch("deleteRecProtocol", this.data);
           await this.$store.dispatch("listRecProtocols");     
           break;
        }
      }
      this.saveState(false);
      this.modalEvent(false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/General/Defination/modals/Delete.vue